import { render, staticRenderFns } from "./DownloadDatasetHistoryModal.vue?vue&type=template&id=7844905c&scoped=true"
import script from "./DownloadDatasetHistoryModal.vue?vue&type=script&lang=js"
export * from "./DownloadDatasetHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadDatasetHistoryModal.vue?vue&type=style&index=0&id=7844905c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844905c",
  null
  
)

export default component.exports